import React from 'react'
import loadable from '@loadable/component'
import PropTypes from 'prop-types'
import { StyledContentContainer } from './styles'
import { styles } from './theme'

const Content = loadable(() =>
  import('@albatross/common-components/dist/components/Content')
)

const ContentContainer = (props) => {
  const ventureStyles = styles[props.venture] ? styles[props.venture] : styles.default

  return (
    <StyledContentContainer
    styles={ventureStyles}
    isNavMenuPresent={props.isNavMenuPresent}
    id={props.anchorId}
    >
      <Content
        {...props}
      />
    </StyledContentContainer>
  )
}

ContentContainer.propTypes = {
  venture: PropTypes.string,
  isNavMenuPresent: PropTypes.bool,
  anchorId: PropTypes.string
}

export default ContentContainer
